/** Quiz Set API */
import { apiClient } from './client'
import type { ApiResponse } from '@/types/api'
import type {
  QuizSetSummary,
  QuizSetDetail,
  QuizSetMetadataUpdate,
} from '@/types/quizSet'

export const getQuizSets = async (params?: {
  levelType?: string
  levelValue?: string
}): Promise<QuizSetSummary[]> => {
  const response = await apiClient.get<ApiResponse<QuizSetSummary[]>>('/quiz-sets', {
    params,
  })
  return response.data.data!
}

/**
 * 세트 상세(멤버 해석). quizId가 members[].quiz / members[].group.items[].quiz에 박혀 있어
 * 응답을 text로 받아 "quizId": number → "quizId": "number" 정규화 후 파싱(JS 정밀도 보호).
 */
export const getQuizSet = async (id: number): Promise<QuizSetDetail> => {
  const response = await apiClient.get<string>(`/quiz-sets/${id}`, {
    responseType: 'text',
  })
  const normalized = response.data.replace(/"quizId"\s*:\s*(\d+)/g, '"quizId":"$1"')
  const parsed = JSON.parse(normalized) as ApiResponse<QuizSetDetail>
  if (!parsed.data) throw new Error('Invalid quiz set response')
  return parsed.data
}

export const updateQuizSet = async (
  id: number,
  request: QuizSetMetadataUpdate,
): Promise<QuizSetDetail> => {
  const response = await apiClient.put<ApiResponse<QuizSetDetail>>(`/quiz-sets/${id}`, request)
  return response.data.data!
}

export const deleteQuizSet = async (id: number): Promise<void> => {
  await apiClient.delete(`/quiz-sets/${id}`)
}

export const reorderQuizSets = async (setIds: number[]): Promise<void> => {
  await apiClient.put('/quiz-sets/reorder', { setIds })
}
